export default __webpack_public_path__ + "static/garden_design18-44cd89ded0f8741a0ba1dddcd228dd2e.webp";